var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbumBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5C22.5523 5 23 5.44772 23 6V20C23 21.1046 22.1046 22 21 22H5C4.44772 22 4 21.5523 4 21C4 20.4477 4.44772 20 5 20H21V6C21 5.44772 21.4477 5 22 5Z",
    fill: "#101820"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1C0.447715 1 0 1.44772 0 2V18C0 18.5523 0.447715 19 1 19H19C19.5523 19 20 18.5523 20 18V2C20 1.44772 19.5523 1 19 1H1ZM11.5633 5.46518C11.87 5.16733 12.2861 5 12.72 5C13.1538 5 13.5699 5.16733 13.8766 5.46518C14.1834 5.76304 14.3558 6.16701 14.3558 6.58824C14.3558 7.00946 14.1834 7.41344 13.8766 7.71129C13.5699 8.00914 13.1538 8.17647 12.72 8.17647C12.2861 8.17647 11.87 8.00914 11.5633 7.71129C11.2565 7.41344 11.0842 7.00946 11.0842 6.58824C11.0842 6.16701 11.2565 5.76304 11.5633 5.46518ZM7.72418 8.62626C7.81497 8.51191 7.94928 8.45677 8.08308 8.45875C8.21687 8.46074 8.35047 8.5196 8.43771 8.6366L9.96169 10.6788L8.78809 12.0044C8.46311 12.3712 8.73061 12.9396 9.22899 12.9412C9.39911 12.9417 9.56078 12.8707 9.67201 12.7457L12.2365 9.86707C12.4148 9.66695 12.7344 9.66847 12.9117 9.87017L15.8893 13.2617C16.144 13.5524 15.931 14 15.5379 14H4.53246C4.09135 14 3.8419 13.5075 4.1118 13.1687L7.72418 8.62626Z",
    fill: "#101820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumBlack);
export default __webpack_public_path__ + "static/media/album-black.bf8c6110da5ae638cd2d28949776a1d3.svg";
export { ForwardRef as ReactComponent };